import React, { createContext, useContext, useCallback, useMemo } from 'react';
import SocketInterface from '../interface/socket_interface';
import { useWebInterface } from '../interface/web_interface';
import { Outlet } from 'react-router-dom';

const SocketContext = createContext(null);

export const useSocket = () => {
	const socket = useContext(SocketContext);
	if (!socket) {
		throw new Error('useSocket must be used within a SockerProvider');
	}
	return socket;
};

export const useSendUserInput = () => {
	const socket = useSocket();
	return useCallback(
		(msg) => {
			socket.send(JSON.stringify(msg));
		},
		[socket],
	);
};

export const SocketProvider = () => {
	const config = useWebInterface();

	const socket = useMemo(() => {
		return new SocketInterface(config);
	}, []);
	return (
		<SocketContext.Provider value={socket}>
			<Outlet />
		</SocketContext.Provider>
	);
};
